export enum DateFormats {
    REQ = "YYYY-MM-DD",
    NIN = "DDMMYY",
    MIN_DATE = "0001-01-01",
}
